export const configs ={"apiUrl":"https://api.onelightapps.io"}